import React, { useState } from "react";

const Footer = () => {
  const [showInfo, setShowInfo] = useState(false);

  const openInfo = () => setShowInfo(true);
  const closeInfo = () => setShowInfo(false);

  return (
    <footer className="main-footer p-1">
      <div className="row ml5">
        <div className="footer-equal-row align-items-center">
          <a
            href="https://mtu.gov.ua/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="pr-4"
              src={`${process.env.PUBLIC_URL}logo-dark-miu-ukr.svg`}
              alt="Ministry for Development of Communities and Territories of Ukraine"
              height="48"
            />
          </a>

          <a
            href="https://dsbt.gov.ua/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="pr-4"
              src={`${process.env.PUBLIC_URL}dsbt.png`}
              alt="Державна служба України з безпеки на транспорті"
              height="48"
            />
          </a>

          <a rel="noopener noreferrer">
            <img
              className="pr-4"
              src={`${process.env.PUBLIC_URL}UK Dev.svg`}
              alt="UK DEV - Digital Professionals"
              height="48"
            />
          </a>

          <a
            href="https://www.eurasia.org/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              className="pr-4"
              src={`${process.env.PUBLIC_URL}EF_logo-horizontal-b.svg`}
              alt="Фонд Євразія"
              height="48"
            />
          </a>

          {/* Disclaimer button as an equal item */}
          <button
            type="button"
            className="info-btn btn btn-light rounded-pill d-flex align-items-center justify-content-center"
            onClick={openInfo}
            aria-label="Відкрити дисклеймер"
          >
            <span className="mr-2" aria-hidden="true">
              ⓘ
            </span>
            <span className="info-btn-text">Дисклеймер</span>
          </button>
        </div>
      </div>

      {/* Simple popup/modal */}
      {showInfo && (
        <div
          className="info-modal-backdrop"
          onClick={closeInfo}
        >
          <div
            className="info-modal"
            role="dialog"
            aria-modal="true"
            aria-labelledby="dashboard-info-title"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              type="button"
              className="info-modal-close"
              onClick={closeInfo}
              aria-label="Закрити"
            >
              ×
            </button>

            <h3
              id="dashboard-info-title"
              className="mb-3 info-modal-title"
            >
              Дисклеймер
            </h3>

            <p>
              Дашборд розроблено для Міністерства розвитку громад та територій
              України й Державної служби України з безпеки на транспорті за
              підтримки проєкту &quot;Цифровізація для зростання, доброчесності
              та прозорості&quot; (UK DIGIT), що виконується Фондом Євразія та
              фінансується UK Dev.
            </p>
            <p>
              Цей дашборд створений за фінансової підтримки Програми допомоги з
              міжнародного розвитку від Уряду Великої Британії. Зміст є
              винятковою відповідальністю Міністерства розвитку громад та
              територій України; висловлені погляди не обов’язково відображають
              офіційну політику Уряду Великої Британії.
            </p>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
